/**
 * Geowall & Tobermore Walls Field Mapping
 * Maps field names to their display labels (matching groundworks_rates_mapping.json)
 */

/**
 * Mapping of Geowall & Tobermore Walls field names to their display labels
 */
export const GEO_TOBER_WALL_FIELD_LABELS: { [fieldName: string]: string } = {
  // GEOWALLS - Excavation & Foundation
  'excavateTrenchAndTipOnSite': 'Excavate trench and tip on-site (m³)',
  'compactFormation': 'Compact formation (m²)',
  'concreteBlinding': 'Concrete blinding (m³)',
  'a393Mesh': 'A393 Mesh (m²)',
  'a252Mesh': 'A252 Mesh (m²)',
  'b503Mesh': 'B503 Mesh (m²)',
  'b785Mesh': 'B785 Mesh (m²)',
  'concreteToFoundation': 'Concrete to foundation (m³)',

  // GEOWALLS - Backfill & Drainage
  'asDugBackfill': 'As dug backfill (m²)',
  'stockpileOnsite': 'Stockpile on-site (m)',
  'perforated150mmPipe': 'Perforated 150mm pipe (m)',
  'concreteHaunchingToFront': 'Concrete haunching to front (m)',
  'concreteHaunchingToRear': 'Concrete haunching to rear (m)',
  'granularBackfill': 'Granular backfill (m³)',
  'granularBackfill2': 'Granular backfill (m³)',
  'terram': 'Terram (m)',

  // GEOWALLS - Installation
  'fencePostAt2400mmCcs': 'Fence post at 2400mm ccs (m²)',
  'purchaseInclCarriageWasteFp': 'Purchase incl carriage waste FP (m³)',
  'installGeoWalls': 'Install Geo Walls (m³)',

  // TOBERMORE - Excavation & Preparation
  'excavateInCuttingsFp': 'Excavate in cuttings FP (m³)',
  'excavationOfEmbankment': 'Excavation of embankment (m³)',
  'stockpileOnsiteTobermore': 'Stockpile on-site (m²)',
  'batterToFaceOfEmbankment': 'Batter to face of embankment (m2)',
  'excavationOfBase': 'Excavation of base (m3)',
  'stockpileOnsite2': 'Stockpile on-site (m3)',
  'levelAndCompactFormation': 'Level & compact formation (m3)',
  'concreteToBase': 'Concrete to Base (m2)',

  // TOBERMORE - Wall Installation
  'tobermoreSupplyOfGrandSecuraInclFp': 'Tobermore - supply of Grand Secura incl FP (m2)',
  'tobermoreSecuraInstallationByMj': 'Tobermore Secura installation by MJ (m3)',
  'tobermoreSupplyOfGeogrid': 'Tobermore - supply of geogrid (m3)',
  'mjInstallationOfGeogrid': 'MJ - installation of geogrid (nr)',
  'installGeoWallsTobermore': 'Install Geo Walls (m³)',
  'fencePostAt2400mmCcsTobermore': 'Fence post at 2400mm ccs (m3)',

  // TOBERMORE - Backfill & Drainage
  'freeDrainingGranularBackfill300wColumn': 'Free draining granular backfill 300w column (m3)',
  'granularBackfillToRearOfWall': 'Granular backfill to rear of wall (m)',
  'landDrainToRearOfWall': 'Land drain to rear of wall (nr)',
  'allowSiltTrap': 'Allow silt trap (m)',
  'allowToConnectOfLandDrainToPlotDrainage': 'Allow to connect of land drain to plot drainage (m)',
};

/**
 * Mapping of Geowall & Tobermore Walls field names to their units
 */
export const GEO_TOBER_WALL_FIELD_UNITS: { [fieldName: string]: string } = {
  // GEOWALLS - Excavation & Foundation
  'excavateTrenchAndTipOnSite': 'm³',
  'compactFormation': 'm²',
  'concreteBlinding': 'm³',
  'a393Mesh': 'm²',
  'a252Mesh': 'm²',
  'b503Mesh': 'm²',
  'b785Mesh': 'm²',
  'concreteToFoundation': 'm³',

  // GEOWALLS - Backfill & Drainage
  'asDugBackfill': 'm²',
  'stockpileOnsite': 'm',
  'perforated150mmPipe': 'm',
  'concreteHaunchingToFront': 'm',
  'concreteHaunchingToRear': 'm',
  'granularBackfill': 'm³',
  'granularBackfill2': 'm³',
  'terram': 'm',

  // GEOWALLS - Installation
  'fencePostAt2400mmCcs': 'm²',
  'purchaseInclCarriageWasteFp': 'm³',
  'installGeoWalls': 'm³',

  // TOBERMORE - Excavation & Preparation
  'excavateInCuttingsFp': 'm³',
  'excavationOfEmbankment': 'm³',
  'stockpileOnsiteTobermore': 'm²',
  'batterToFaceOfEmbankment': 'm2',
  'excavationOfBase': 'm3',
  'stockpileOnsite2': 'm3',
  'levelAndCompactFormation': 'm3',
  'concreteToBase': 'm2',

  // TOBERMORE - Wall Installation
  'tobermoreSupplyOfGrandSecuraInclFp': 'm2',
  'tobermoreSecuraInstallationByMj': 'm3',
  'tobermoreSupplyOfGeogrid': 'm3',
  'mjInstallationOfGeogrid': 'Nr',
  'installGeoWallsTobermore': 'm³',
  'fencePostAt2400mmCcsTobermore': 'm3',

  // TOBERMORE - Backfill & Drainage
  'freeDrainingGranularBackfill300wColumn': 'm3',
  'granularBackfillToRearOfWall': 'm',
  'landDrainToRearOfWall': 'Nr',
  'allowSiltTrap': 'm',
  'allowToConnectOfLandDrainToPlotDrainage': 'm',
};

/**
 * Get the display label for a Geowall & Tobermore Walls field
 */
export function getGeoToberWallFieldLabel(fieldName: string): string | undefined {
  return GEO_TOBER_WALL_FIELD_LABELS[fieldName];
}

/**
 * Get the unit for a Geowall & Tobermore Walls field
 */
export function getGeoToberWallFieldUnit(fieldName: string): string | undefined {
  return GEO_TOBER_WALL_FIELD_UNITS[fieldName];
}

/**
 * Reverse mapping: label to field name
 */
export const GEO_TOBER_WALL_REVERSE_MAPPING: { [label: string]: string } = {};
Object.entries(GEO_TOBER_WALL_FIELD_LABELS).forEach(([fieldName, label]) => {
  GEO_TOBER_WALL_REVERSE_MAPPING[label] = fieldName;
});
